import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Tab, Typography } from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TextTabContent from './CreatePostPage/TextTabContent'
import ImageTabContent from './CreatePostPage/ImageTabContent'
import LinkTabContent from './CreatePostPage/LinkTabContent'
import SubmitButton from '../commonUIComponents/SubmitButton'
import { FormProvider } from 'react-hook-form'
import React, { useEffect, useState } from 'react'
import communityService from '../../services/communityService'

const PostForm = ({ postFormTitle, methods, onSubmit, tabValue, setTabValue, editorRef }) => {
  const { handleSubmit, register, formState: { errors } } = methods
  const [communities, setCommunities] = useState([])
  const community = methods.watch('communityId') ? methods.watch('communityId') : ''

  const tabHandler = (event, newValue) => {
    setTabValue(newValue)
  }

  const fetchCommunities = () => {
    communityService.fetchCommunities()
      .then(res => {
        setCommunities(res)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    fetchCommunities()
  }, [])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5" component="div" sx={{ pt: 3, pl: 3, fontWeight: 'bold' }}>
              {postFormTitle}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TabContext value={tabValue}>
              <Box sx={{ pl: 3 }}>
                <TabList onChange={tabHandler} aria-label="post tab">
                  <Tab label="Text" value="text" sx={{ fontSize: '12px', fontWeight: 'bold' }}/>
                  <Tab label="Images & Videos" value="images" sx={{ fontSize: '12px', fontWeight: 'bold' }}/>
                  <Tab label="Link" value="link" sx={{ fontSize: '12px', fontWeight: 'bold' }}/>
                  <Tab label="Poll" value="poll" sx={{ fontSize: '12px', fontWeight: 'bold' }} disabled/>
                </TabList>
              </Box>
              <Box sx={{ paddingTop: 3, paddingX: 3 }}>
                <FormControl fullWidth>
                   <InputLabel>Community</InputLabel>
                   <Select
                    label="Community"
                    {...register('communityId', { required: { value: true, message: 'Invalid Community' } })}
                    value={community}
                   >
                    {communities?.map(community => <MenuItem key={community.id} value={community.id}>{community.id}</MenuItem>)}
                   </Select>
                </FormControl>
              </Box>
              <Box>
                <TabPanel value="text">
                  <TextTabContent editorRef={editorRef}/>
                </TabPanel>
                <TabPanel value="images">
                  <ImageTabContent/>
                </TabPanel>
                <TabPanel value="link">
                  <LinkTabContent/>
                </TabPanel>
              </Box>
            </TabContext>
          </Grid>
        </Grid>
        <SubmitButton buttonLabel="Post" loadingLabel="Posting..." textAlign="right"/>
      </form>
    </FormProvider>
  )
}

export default PostForm
